<template>
  <div class="empty-state">
    <material-icon :name="icon" :type="iconType" size="70" color="#ccc" />
    <h3 class="title">{{ title }}</h3>
    <p class="description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "empty-state",
  props: {
    icon: {
      type: String,
      default: "folder",
    },
    iconType: {
      type: String,
      default: "outlined",
      validator(value) {
        return ["filled", "outlined", "rounded", "sharp", "two-tone"].includes(
          value
        );
      },
    },
    title: {
      type: String,
      default: "Tidak ada data",
    },
    description: {
      type: String,
      default: "Saat ini belum ada data yang tersedia",
    },
  },
};
</script>

<style lang="sass" scoped>
.empty-state
  text-align: center
  padding: 40px 20px

  .title
    margin-top: 15px
    margin-bottom: 0
    color: #666
  .description
    margin-top: 0
    color: #aaa
</style>
